import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertCard = ({ alert }) => {
  const priorityConfig = {
    high: {
      bgColor: 'bg-error/10',
      borderColor: 'border-error/30',
      iconColor: 'text-error',
      icon: 'AlertTriangle'
    },
    medium: {
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/30',
      iconColor: 'text-warning',
      icon: 'AlertCircle'
    },
    low: {
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/30',
      iconColor: 'text-accent',
      icon: 'Info'
    }
  };

  const config = priorityConfig?.[alert?.priority] || priorityConfig?.medium;

  const typeIcons = {
    security: 'Shield',
    compliance: 'FileText',
    system: 'Server'
  };

  return (
    <div className={`rounded-xl p-4 border-2 ${config?.bgColor} ${config?.borderColor}`}>
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg bg-card flex items-center justify-center flex-shrink-0`}>
          <Icon name={typeIcons?.[alert?.type] || 'Bell'} size={20} className={config?.iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h3 className="text-sm font-semibold text-foreground">{alert?.title}</h3>
            <span className="text-xs text-muted-foreground whitespace-nowrap">{alert?.time}</span>
          </div>
          <p className="text-sm text-muted-foreground mb-3">{alert?.description}</p>
          <div className="flex items-center gap-2">
            <Button size="xs" variant="outline">
              Investigate
            </Button>
            <Button size="xs" variant="ghost">
              Dismiss
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertCard;